module.exports = __webpack_public_path__ + "img/yancao_shifang_suoluetu.26c81072.png";